module.exports = __webpack_public_path__ + "img/wallet.5932e333.svg";